import React from 'react';
import Paper from '@material-ui/core/Paper';
import LineChart from '../components/LineChart';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import useStyles from '../components/styles/reports.styles';

function ChartWrapper({ children, title }) {
	const classes = useStyles();

	return (
		<Paper className={classes.chartContainer}>
			<div className={classes.titleContainer}>
				<Typography className={classes.title}>{title}</Typography>
				<Divider />
			</div>
			<div className={classes.padding}>{children}</div>
		</Paper>
	);
}

export default ChartWrapper;
